module.exports = __webpack_public_path__ + "img/6.2d81ae5c.png";